import React from 'react';
import './FloatingWhatsAppButton.css';

const phoneNumber = '5514997002166';
const message = encodeURIComponent('Olá! Encontrei vocês no site e gostaria de saber mais.');
const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

function FloatingWhatsAppButton() {
  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-whatsapp-button"
      aria-label="Fale conosco no WhatsApp"
    >
      <img src='./images/logo_whatsapp_100.png' alt='WhatsApp' className='whatsapp-icon-desktop' />
      <img src='./images/logo_whatsapp_50.png' alt='WhatsApp' className='whatsapp-icon-mobile' />
    </a>
  );
}

export default FloatingWhatsAppButton;
